import Dialog from "./Dialog";
import React, {useContext, useState} from "react";
import {wrapLoaderPromise} from "../wrapper";
import AppContext from "../appContext";

export interface SharedJson {
    original: void | null;
    mapped: object | null;
    data: object | null;
}

const ShowJsonData: React.FC<{
    callback: () => Promise<SharedJson>;
}> = (props) => {
    const context = useContext(AppContext)
    const [jsonData, setJsonData] = useState<SharedJson>()
    const [showJson, setShowJson] = useState<boolean>(false)

    function getJson() {
        wrapLoaderPromise(context, props.callback(), resp => {
            setShowJson(true)
            setJsonData(resp)
        })
    }

    return <div>
        <button className="btn-primary btn-sm" onClick={_ => getJson()}>json</button>

        <Dialog show={showJson} setShow={setShowJson} title="Json" body={<>
            <div className="flex text-left">
                <div className="w-1/2 px-2">
                    <p className="text-xl font-bold">Originallly</p>
                    <pre className="whitespace-pre-wrap break-words text-xs">{JSON.stringify(jsonData?.original)}</pre>
                </div>
                <div className="w-1/2 px-2">
                    <p className="text-xl font-bold">Mapped</p>
                    <pre className="whitespace-pre-wrap text-xs">{JSON.stringify(jsonData?.mapped)}</pre>
                </div>
            </div>
            <div className="px-2">
                <p className="text-xl font-bold">Test Farmers Sample Data</p>
                <pre className="whitespace-pre-wrap text-xs">{JSON.stringify(jsonData?.data)}</pre>
            </div>
        </>}/>
    </div>
}

export default ShowJsonData;